import React, { useState, useRef } from 'react';
import './RegisterPage.css';
import { auth, db } from './firebase';
import { createUserWithEmailAndPassword, updateProfile, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function RegisterPage() {
  const [nome, setNome] = useState('');
  const [sobrenome, setSobrenome] = useState('');
  const [email, setEmail] = useState('');
  const [estado, setEstado] = useState('');
  const [senha, setSenha] = useState('');
  const [repetirSenha, setRepetirSenha] = useState('');

  const [mensagem, setMensagem] = useState('');
  const [tipoMensagem, setTipoMensagem] = useState('');
  const [mensagemPopup, setMensagemPopup] = useState('');
  const [tipoMensagemPopup, setTipoMensagemPopup] = useState('');
  const [mostrarPopup, setMostrarPopup] = useState(false);

  const usuarioCriadoRef = useRef(null);

  const navigate = useNavigate();

  const reenviarEmailVerificacao = async () => {
    try {
      const user = usuarioCriadoRef.current;
      if (user && !user.emailVerified) {
        await sendEmailVerification(user);
        setMensagemPopup("Novo e-mail de verificação enviado!");
        setTipoMensagemPopup("sucesso");
      } else {
        setMensagemPopup("O utilizador não está autenticado ou já confirmou o e-mail.");
        setTipoMensagemPopup("erro");
      }
    } catch (erro) {
      console.error("Erro ao reenviar e-mail:", erro);
      setMensagemPopup("Erro ao reenviar o e-mail. Espere alguns minutos e tente novamente.");
      setTipoMensagemPopup("erro");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nome || !sobrenome || !email || !estado || !senha || !repetirSenha) {
      setMensagem('Por favor, preencha todos os campos.');
      setTipoMensagem('erro');
      return;
    }

    if (senha !== repetirSenha) {
      setMensagem('As senhas não coincidem.');
      setTipoMensagem('erro');
      return;
    }

    try {
      // ✅ 1) Cria a conta (se isto falhar, exibimos erro global)
      const usuario = await createUserWithEmailAndPassword(auth, email, senha);
      usuarioCriadoRef.current = usuario.user;
      setMostrarPopup(true); // conta criada com sucesso → mostra popup

      // ✅ 2) Atualiza perfil de auth (displayName)
      try {
        await updateProfile(usuario.user, {
          displayName: `${nome} ${sobrenome}`
        });
      } catch (e) {
        console.warn('Aviso: não foi possível atualizar displayName:', e);
      }

      // ✅ 3) Cria/atualiza documento do usuário no Firestore (não derruba o fluxo se falhar)
      try {
        await setDoc(doc(db, 'usuarios', usuario.user.uid), {
          nome: nome,
          sobrenome: sobrenome,
          email: email,
          estado: estado,
          fotoPerfil: '',
          fotoCabecalho: '',
          criadoEm: new Date().toISOString(),
          ultimaatualizacao: new Date().toLocaleString(),
          pontuacao: 0,
          selooficial: 'estreia-oficial',
          selosGanhos: ['estreia-oficial'],
          amigos: [],
          amizadesPendentes: {
            enviadas: [],
            recebidas: []
          }
        }, { merge: true });
      } catch (e) {
        console.warn('Aviso: não foi possível salvar perfil em "usuarios":', e);
      }

      // ✅ 4) Envia e-mail de verificação
      try {
        await sendEmailVerification(usuario.user);
      } catch (e) {
        console.warn('Aviso: falha ao enviar e-mail de verificação:', e);
      }

      // ✅ 5) Tenta gravar no mapaEmailsParaUIDs (muitas vezes tem regras mais fechadas)
      try {
        const emailID = email.toLowerCase().replace(/\./g, ',');
        await setDoc(doc(db, 'mapaEmailsParaUIDs', emailID), {
          uid: usuario.user.uid,
          email: email.toLowerCase(),
          nome: `${nome} ${sobrenome}`
        }, { merge: true });
      } catch (e) {
        console.warn('Aviso: não foi possível escrever em "mapaEmailsParaUIDs":', e);
      }

    } catch (erro) {
      // ❗️Somente erros da criação de conta caem aqui
      console.error('Erro ao registrar:', erro);

      if (erro.code === 'auth/email-already-in-use') {
        setMensagem('Este email já está registrado. Tente fazer login ou usar outro e-mail.');
        setTipoMensagem('erro');
      } else if (erro.code === 'auth/invalid-email') {
        setMensagem('O email inserido não é válido.');
        setTipoMensagem('erro');
      } else if (erro.code === 'auth/weak-password') {
        setMensagem('A senha é muito fraca. Use pelo menos 6 caracteres.');
        setTipoMensagem('erro');
      } else {
        setMensagem('Erro ao registrar: ' + erro.message);
        setTipoMensagem('erro');
      }
    }
  };

  return (
    <div className="register-container">
      <div className="register-logo">
        <div className="register-logo-box">
          <img src="https://i.imgur.com/atZYcGp.png" alt="Termometeiro" />
        </div>
      </div>

      <h1 className="register-title">REGISTRAR</h1>

      {mensagem && (
        <div className={`mensagem ${tipoMensagem}`}>
          {mensagem}
        </div>
      )}

      <form className="register-form" onSubmit={handleSubmit} autoComplete="off">
        <div className="register-row">
          <input type="text" placeholder="Nome" value={nome} onChange={(e) => setNome(e.target.value)} autoComplete="off" />
          <input type="text" placeholder="Sobrenome" value={sobrenome} onChange={(e) => setSobrenome(e.target.value)} autoComplete="off" />
        </div>
        <input type="email" placeholder="Endereço de e-mail" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off" />
        <select value={estado} onChange={(e) => setEstado(e.target.value)}>
          <option value="">ESTADO</option>
          <option value="AC">Acre</option>
          <option value="AL">Alagoas</option>
          <option value="AP">Amapá</option>
          <option value="AM">Amazonas</option>
          <option value="BA">Bahia</option>
          <option value="CE">Ceará</option>
          <option value="DF">Distrito Federal</option>
          <option value="ES">Espírito Santo</option>
          <option value="GO">Goiás</option>
          <option value="MA">Maranhão</option>
          <option value="MT">Mato Grosso</option>
          <option value="MS">Mato Grosso do Sul</option>
          <option value="MG">Minas Gerais</option>
          <option value="PA">Pará</option>
          <option value="PB">Paraíba</option>
          <option value="PR">Paraná</option>
          <option value="PE">Pernambuco</option>
          <option value="PI">Piauí</option>
          <option value="RJ">Rio de Janeiro</option>
          <option value="RN">Rio Grande do Norte</option>
          <option value="RS">Rio Grande do Sul</option>
          <option value="RO">Rondônia</option>
          <option value="RR">Roraima</option>
          <option value="SC">Santa Catarina</option>
          <option value="SP">São Paulo</option>
          <option value="SE">Sergipe</option>
          <option value="TO">Tocantins</option>
        </select>
        <input type="password" placeholder="Senha" value={senha} onChange={(e) => setSenha(e.target.value)} autoComplete="new-password" />
        <input type="password" placeholder="Repetir senha" value={repetirSenha} onChange={(e) => setRepetirSenha(e.target.value)} autoComplete="new-password" />
        <button type="submit" className="register-button">C O N F I R M A R</button>
      </form>

      {mostrarPopup && (
        <div className="popup-container">
          <div className="popup">
            <p>Conta criada com sucesso! Verifique o seu email antes de fazer login (pode estar na pasta de spam ou lixo).</p>

            {mensagemPopup && (
              <p className={`mensagem ${tipoMensagemPopup}`}>{mensagemPopup}</p>
            )}

            <div className="popup-buttons">
              <button className="popup-button" onClick={() => navigate('/')}>Já confirmei</button>
              <button className="popup-button" onClick={reenviarEmailVerificacao}>Reenviar e-mail</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default RegisterPage;
